import * as React from 'react'
import {
  IonFab,
  IonFabButton,
  IonIcon,
  IonModal,
  useIonActionSheet,
} from '@ionic/react'

import { add } from 'ionicons/icons'
import SelectShopWithModal from '../shopwith/select-shop-with-modal'
import { PhotoData, usePhoto } from '../../hooks/use-photo'
import { isPlatform } from '@ionic/core'

type shopWithKeys = 'productIds' | 'lookIds' | 'collectionIds'
type Props = {
  onShopWithSelected: (type: shopWithKeys, value: Array<string>) => void
  onSelectPhoto: (data: PhotoData) => void
  onTakePhoto: (data: PhotoData) => void
}

function BroadcastFab({
  onShopWithSelected,
  onSelectPhoto,
  onTakePhoto,
}: Props) {
  const [isShopWithModalOpen, setIsShopWithModalOpen] = React.useState(false)
  const [present] = useIonActionSheet()
  const { selectPhotos, takePhoto } = usePhoto()

  function handleShopWithModalOnClose() {
    setIsShopWithModalOpen(false)
  }

  function handleShopWithModalOnConfirm(
    type: shopWithKeys,
    value: Array<string>
  ) {
    setIsShopWithModalOpen(false)
    onShopWithSelected(type, value)
  }

  const buttons = isPlatform('desktop')
    ? [
        {
          text: 'Add Product',
          handler: () => setIsShopWithModalOpen(true),
        },
        {
          text: 'Select Photo',
          handler: () => selectPhotos(onSelectPhoto),
        },
        {
          text: 'Cancel',
        },
      ]
    : [
        {
          text: 'Add Product',
          handler: () => setIsShopWithModalOpen(true),
        },
        {
          text: 'Take Photo',
          handler: () => takePhoto(onTakePhoto),
        },
        {
          text: 'Select Photo',
          handler: () => selectPhotos(onSelectPhoto),
        },
        {
          text: 'Cancel',
        },
      ]

  return (
    <>
      <IonFab vertical="bottom" horizontal="end" className="fixed">
        <IonFabButton
          size="small"
          color="yellow"
          onClick={() => {
            present({
              cssClass: 'action-sheet',
              buttons,
            })
          }}
        >
          <IonIcon icon={add} />
        </IonFabButton>
      </IonFab>

      <IonModal
        isOpen={isShopWithModalOpen}
        onDidDismiss={handleShopWithModalOnClose}
      >
        <SelectShopWithModal
          onClose={handleShopWithModalOnClose}
          onConfirm={handleShopWithModalOnConfirm}
        />
      </IonModal>
    </>
  )
}

export default BroadcastFab
